import { Box, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  CubeDimensionEnum,
  FeatureEnum,
} from '../../services/data/impl/cube/cubeSlice';
import { useTranslation } from '../../services/translation/hooks/useTranslation';
import Dropdown from '../commonUI/Dropdown';
import useCurrServicesAndMeasures from '../customerSummary/hooks/useCurrServicesAndMeasures';
import { selectCurrFeature, setCurrFeature } from '../select/selectSlice';
import { ChartProvider } from './ChartProvider';
import RenderChart from './RenderChart';
enum DimensionsEnum {
  avgMeteredCount = 'avgMeteredCount',
  stdDevMeteredCount = 'stdDevMeteredCount',
}

enum DimensionsNameEnum {
  avgMeteredCount = 'Average metered count per block',
  stdDevMeteredCount = 'Standard deviation of metered count per block',
}

const ChartRanchView: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const currFeature = useAppSelector(selectCurrFeature);
  const { servicesAndMeasuresWithFeatureFilter } = useCurrServicesAndMeasures();
  const [currDimension, setCurrDimension] = useState<DimensionsEnum>(
    DimensionsEnum.avgMeteredCount
  );

  return (
    <Box
      sx={{
        padding: '16px 16px 16px 16px',
        height: '100%',
        width: '100%',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          right: '3rem',
          top: '2rem',
        }}
      >
        <Dropdown
          label={"doesn't matter"}
          value={currFeature}
          onChange={(e) => {
            dispatch(setCurrFeature(e.target.value as FeatureEnum));
          }}
          colorScheme='dark'
          items={Object.values(FeatureEnum).map((el: FeatureEnum) => {
            return (
              <MenuItem
                key={el}
                value={el}
                disabled={
                  !servicesAndMeasuresWithFeatureFilter.availableServicesRaw.find(
                    (aiClass) => aiClass[CubeDimensionEnum.modelName] === el
                  )
                }
              >
                {t('el', { ns: 'common' })}
              </MenuItem>
            );
          })}
        />
        <Dropdown
          label={"doesn't matter"}
          value={currDimension}
          onChange={(e) => {
            setCurrDimension(e.target.value as DimensionsEnum);
          }}
          colorScheme='dark'
          items={Object.values(DimensionsEnum).map((el: DimensionsEnum) => {
            return (
              <MenuItem key={el} value={el}>
                {DimensionsNameEnum[el]}
              </MenuItem>
            );
          })}
        />
      </Box>
      <ChartProvider>
        <RenderChart chartType='bar' />
      </ChartProvider>
    </Box>
  );
};

export default ChartRanchView;
